'use client';

import Link from 'next/link';
import GomokuGame from './components/GomokuGame';

export default function GomokuPage() {
  return (
    <main className="min-h-screen bg-gradient-to-b from-blue-100 to-indigo-100 text-gray-700 py-8">
      <div className="container mx-auto">
        <div className="text-center mb-8">
          <Link href="/" className="text-indigo-600 hover:text-indigo-800 flex items-center justify-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
            </svg>
            Back to Home
          </Link>
        </div>
        
        <GomokuGame />
        
        <div className="max-w-lg mx-auto mt-12 p-4 bg-white/70 rounded-lg shadow-sm">
          <h2 className="text-xl font-semibold mb-3 text-indigo-700">How to Play Gomoku</h2>
          <ol className="list-decimal list-inside space-y-1 text-gray-700">
            <li>Take turns placing stones on the board</li>
            <li>Black plays first, followed by White</li>
            <li>The goal is to get five of your stones in a row</li>
            <li>Stones can be aligned horizontally, vertically, or diagonally</li>
            <li>The first player to get five stones in a row wins</li>
          </ol>
          
          <p className="mt-4 text-sm text-gray-600">
            Gomoku, also called Five in a Row, is a traditional strategy board game 
            that originated in Japan. It's a perfect game for a quick mental break!
          </p>
        </div>
      </div>
    </main>
  );
}